import { render } from "./OptionChipPicker.vue?vue&type=template&id=246afe4e&scoped=true"
import script from "./OptionChipPicker.vue?vue&type=script&lang=js"
export * from "./OptionChipPicker.vue?vue&type=script&lang=js"

import "./OptionChipPicker.vue?vue&type=style&index=0&id=246afe4e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\מפתח רוסמן\\Desktop\\Projects\\RosmanNext\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-246afe4e"]])

export default __exports__